import { render } from "./ArchivedIndex.vue?vue&type=template&id=d48e4e12&scoped=true"
import script from "./ArchivedIndex.vue?vue&type=script&lang=js"
export * from "./ArchivedIndex.vue?vue&type=script&lang=js"

import "./ArchivedIndex.vue?vue&type=style&index=0&id=d48e4e12&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48e4e12"]])

export default __exports__